<template>
  <validation-observer ref="createDocument">
    <b-form
        @submit.prevent="handleSubmit"
        @keydown.enter="handleSubmit"
    >
      <!-- Sección Imagen/Avatar -->
      <b-row>
        <b-col cols="12" v-if="showUserSelect">
          <validation-provider
              #default="{ errors }"
              :name="'Usuario'"
              rules="required"
          >
            <b-form-checkbox
                v-model="publicDocument"
                :value="1"
                class="d-inline-block mb-2 mt-1"
                switch
                inline
            >
              Documento público
            </b-form-checkbox>
            <b-alert v-if="publicDocument === 1" show variant="info" class="mb-2">
              <div class="alert-body">
                <span class="small">
                  <feather-icon icon="InfoIcon" size="20" />
          Los documentos públicos pueden ser <strong>visualizados por todos los usuarios</strong> de la plataforma.
        </span>
              </div>
            </b-alert>
            <b-form-group
                :label="'Usuario'"
                label-for="users"
                v-if="publicDocument != 1"
            >
              <BaseSelect
                  v-model="userSelect"
                  :searchable="true"
                  :clearable="true"
                  :multiple="false"
                  :httpBody="{
                      client_id: currentClient.id,
                      active: 1,
                    }"
                  :resource="'/users'"
              />
            </b-form-group>
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-col>
        <b-col :cols="12">
          <validation-provider
              #default="{ errors }"
              name="Nombre"
              rules="required"
          >
            <b-form-group label="Nombre" label-for="document-name">
              <b-form-input
                  v-model="name"
                  name="name"
                  placeholder="Nombre"
              />
            </b-form-group>
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-col>
        <b-col cols="12">
          <b-form-group label="Tipo de documento" label-for="document-type">
            <b-form-radio-group
                v-model="documentType"
                :options="documentTypeOptions"
                name="document-type"
            />
          </b-form-group>
        </b-col>
        <b-col cols="12" v-if="documentType === 'file'">
          <b-form-group label="Archivo" label-for="document-file">
            <FileDropzone ref="files" :files="files" label="Cargar archivo" />
          </b-form-group>
        </b-col>
        <b-col cols="12" v-if="documentType === 'url'">
          <validation-provider
              #default="{ errors }"
              name="URL externa"
              rules="required|web"
          >
            <b-form-group label="URL externa" label-for="external-url">
              <b-form-input
                  v-model="externalUrl"
                  name="external_url"
                  placeholder="https://ejemplo.com/documento.pdf"
              />
            </b-form-group>
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-col>
        <b-col cols="12" class="mb-1">
          <validation-provider
              #default="{ errors }"
              :name="'Categoría'"
              rules="required"
          >
            <b-form-group
                :label="'Categoría'"
                label-for="document-category"
            >
              <BaseSelect
                  v-model="category"
                  :searchable="true"
                  :clearable="true"
                  :multiple="false"
                  :httpBody="{
                      client_id: currentClient.id,
                      active: 1,
                    }"
                  :resource="'/document-categories'"
              />
            </b-form-group>
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-col>
      </b-row>
      <div :class="showBackButton ? 'd-flex justify-content-between align-items-center' : 'text-right'">
        <b-button
            v-if="showBackButton"
            variant="outline-primary"
            @click="$emit('back')"
        >
          Volver
        </b-button>
        <b-button
            type="submit"
            variant="primary"
        >
          {{ 'Enviar' }}
        </b-button>
      </div>
    </b-form>
  </validation-observer>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import {
  BButton, BForm, BFormGroup, BFormInput, BRow, BCol, BFormCheckbox, BAlert, BFormRadioGroup,
} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import Ripple from 'vue-ripple-directive'
import FileDropzone from '@/components/elements/FileDropzone/FileDropzone.vue'
import BaseSelect from '@/components/ui/select/BaseSelect.vue'

export default {
  props: {
    showUserSelect: {
      type: Boolean,
      default: () => false,
    },
    showBackButton: {
      type: Boolean,
      default: () => false,
    },
  },
  components: {
    BFormCheckbox,
    BButton,
    BForm,
    BFormGroup,
    BRow,
    BCol,
    BAlert,
    BFormRadioGroup,
    FileDropzone,
    ValidationProvider,
    ValidationObserver,
    BFormInput,
    BaseSelect,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      publicDocument: 0,
      userSelect: '',
      name: '',
      category: '',
      files: [],
      documentType: 'file',
      documentTypeOptions: [
        { text: 'Subir archivo', value: 'file' },
        { text: 'URL externa', value: 'url' },
      ],
      externalUrl: '',
    }
  },
  computed: {
    ...mapGetters({
      user: 'users/getUser',
      currentClient: 'clients/getCurrentClient',
    }),
  },
  watch: {
    publicDocument() {
      this.userSelect = ''
    },
  },
  methods: {
    ...mapActions({
      create: 'documents/createDocument',
    }),
    handleSubmit() {
      this.$refs.createDocument.validate().then(success => {
        if (success) {
          const formData = this.createFormData()
          if (formData) {
            this.create(formData)
          }
        }
      })
    },
    createFormData() {
      let data

      if (this.documentType === 'file') {
        data = this.$refs.files.getFormData()
      } else {
        data = new FormData()
        data.append('external_url', this.externalUrl)
      }

      data.append('name', this.name)
      data.append('client_id', this.currentClient.id)
      if (this.showUserSelect) {
        data.append('user_id', this.userSelect ? this.userSelect.id : '')
      } else {
        data.append('user_id', this.user.id)
      }
      data.append('category.id', this.category.id)

      return data
    },
  },
}
</script>
